// src/components/StickyFooter.js

import React, { useEffect, useState } from "react";
import CameraModal from "./CameraModal";

import LiveTvRoundedIcon from "@mui/icons-material/LiveTvRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import LibraryMusicRoundedIcon from "@mui/icons-material/LibraryMusicRounded";
import ShoppingBagRoundedIcon from "@mui/icons-material/ShoppingBagRounded";

export default function StickyFooter() {

  const [open, setOpen] = useState(false);

  // detect mobile (show only on mobile devices)
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {

    const checkMobile = () => {

      setIsMobile(window.innerWidth <= 900);

    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);

  }, []);

  // hide/show floating on scroll
  const [visible, setVisible] = useState(true);

  useEffect(() => {

    let last = window.scrollY;

    const onScroll = () => {

      const y = window.scrollY;

      setVisible(y < last || y < 50);

      last = y;

    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);

  }, []);

  if (!isMobile) return null;

  return (
    <>
      <CameraModal
        open={open}
        onClose={() => setOpen(false)}
      />

      <div
        className={`sticky-footer ${visible ? "visible" : "hidden"}`}
        style={footerWrapStyle}
      >

        <div style={footerInnerStyle}>

          {/* Live TV */}
          <button style={iconBtn} title="Live">
            <LiveTvRoundedIcon fontSize="medium" />
          </button>

          {/* Search */}
          <button style={iconBtn} title="Search">
            <SearchRoundedIcon fontSize="medium" />
          </button>

          {/* Create */}
          <button
            style={createBtn}
            title="Create"
            onClick={() => setOpen(true)}
          >
            <AddRoundedIcon fontSize="large" />
          </button>

          {/* Music */}
          <button style={iconBtn} title="Music">
            <LibraryMusicRoundedIcon fontSize="medium" />
          </button>

          {/* Shopping */}
          <button style={iconBtn} title="Shopping">
            <ShoppingBagRoundedIcon fontSize="medium" />
          </button>

        </div>

      </div>

      <style>{footerCss}</style>

    </>
  );

}

const footerWrapStyle = {
  position: "fixed",
  left: 0,
  right: 0,
  bottom: 18,
  display: "flex",
  justifyContent: "center",
  zIndex: 99998,
  pointerEvents: "none"
};

const footerInnerStyle = {
  width: "min(980px, 96%)",
  display: "flex",
  gap: 14,
  background:
    "linear-gradient(90deg, rgba(12,12,14,0.9), rgba(8,8,10,0.85))",
  padding: "10px 18px",
  borderRadius: 999,
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
  pointerEvents: "auto",
  border: "1px solid rgba(255,255,255,0.03)"
};

const iconBtn = {
  background: "transparent",
  color: "#fff",
  border: "none",
  padding: "10px 12px",
  borderRadius: 10,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const createBtn = {
  width: 64,
  height: 64,
  borderRadius: 999,
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg,#ff6ec4,#7873f5)",
  color: "#fff",
  boxShadow: "0 10px 30px rgba(120,115,245,0.14)",
  cursor: "pointer",
  transform: "translateY(-8px)"
};

const footerCss = `
  .sticky-footer.hidden {
    opacity: 0;
    transform: translateY(20px);
    transition: all 180ms ease;
    pointer-events: none;
  }

  .sticky-footer.visible {
    opacity: 1;
    transform: translateY(0);
    transition: all 220ms cubic-bezier(.2,.9,.2,1);
  }

  @media (max-width:900px) {
    .sticky-footer {
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: auto;
    }

    .sticky-footer .sticky-inner {
      width: 100%;
    }
  }
`;